import { SaleFormInput } from '@src/core/buyerApiClient';

export const organizeFormInputs = (formInputs: SaleFormInput[]): Array<SaleFormInput[]> => {
  const organizedFormInputs: { [key: string]: SaleFormInput[] } = {};

  formInputs.forEach((input) => {
    const objectIndex = `${input.saleTariff!.id}${input.number}`;
    if (organizedFormInputs[objectIndex]) {
      organizedFormInputs[objectIndex]?.push(input);
    } else {
      organizedFormInputs[objectIndex] = [input];
    }
  });

  return Object.entries(organizedFormInputs).map(([_, value]) =>
    value.sort((a, b) => a.formInput.sequence - b.formInput.sequence),
  );
};
